import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { calendarApi } from '@/services/api';
import type { CalendarPreferences } from '@/types/user-preferences';

export const calendarKeys = {
  all: ['calendar'] as const,
  settings: () => [...calendarKeys.all, 'settings'] as const,
};

export function useCalendarSettings() {
  return useQuery({
    queryKey: calendarKeys.settings(),
    queryFn: calendarApi.getCalendarSettings,
  });
}

export function useUpdateCalendarSettings() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: Partial<CalendarPreferences>) => calendarApi.updateCalendarSettings(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: calendarKeys.settings() });
    },
  });
}

export function useRegenerateCalendarToken() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: calendarApi.regenerateCalendarToken,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: calendarKeys.settings() });
    },
  });
}
